import { apiClient } from './apiClient';
import config from '@config';
import { Response } from '@types';


interface UploadResponse {
    id: number;
    filename: string;
    mimetype: string;
    size: number;
    url?: string;
}

/**
 * Upload audio file
 */
export const uploadAudioFile = async (file: File): Promise<UploadResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response: Response<UploadResponse> = await apiClient.post(`${config.API_HOST}/api/v1/media/audio`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }) as any;

    if (!response.ok) {
        throw new Error(response.message || 'Failed to upload audio file');
    }

    return response.data as UploadResponse;
};

/**
 * Upload audio from URL
 */
export const uploadAudioFromUrl = async (url: string, filename?: string): Promise<UploadResponse> => {
    const response: Response<UploadResponse> = await apiClient.post(`${config.API_HOST}/api/v1/media/audio/url`, {
        url,
        filename,
    }) as any;

    if (!response.ok) {
        throw new Error(response.message || 'Failed to upload audio from URL');
    }

    return response.data as UploadResponse;
};

/**
 * Upload PDF file
 */
export const uploadPdfFile = async (file: File): Promise<UploadResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response: Response<UploadResponse> = await apiClient.post(`${config.API_HOST}/api/v1/media/pdf`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }) as any;

    if (!response.ok) {
        throw new Error(response.message || 'Failed to upload PDF file');
    }

    return response.data as UploadResponse;
};

/**
 * Upload PDF from URL
 */
export const uploadPdfFromUrl = async (url: string, filename?: string): Promise<UploadResponse> => {
    const response: Response<UploadResponse> = await apiClient.post(`${config.API_HOST}/api/v1/media/pdf/url`, {
        url,
        filename,
    }) as any;

    if (!response.ok) {
        throw new Error(response.message || 'Failed to upload PDF from URL');
    }

    return response.data as UploadResponse;
};

/**
 * Get audio download URL
 */
export const getAudioDownloadUrl = (id: number): string => {
    return `${config.API_HOST}/api/v1/media/audio/${id}/download`;
};

/**
 * Get PDF download URL
 */
export const getPdfDownloadUrl = (id: number): string => {
    return `${config.API_HOST}/api/v1/media/pdf/${id}/download`;
};
